import { createStyles } from '@material-ui/styles'
import { ThemeType } from 'theme'
import { MOBILE, TABLET } from 'utils/styles'

export const AppStyles = (theme: ThemeType) =>
  createStyles({
    '@global': {
      html: {
        '@media (min-width: 768px)': {
          fontSize: '100%',
        },
        '& body': {
          fontFamily: 'GT-Eesti-Text-Regular',
        },
      },
    },
    'call-to-scroll-container': {
      position: 'fixed',
      top: 0,
      bottom: 0,
      right: 0,
      left: 0,
      transition: 'opacity 0.5s 0.1s, z-index 0s',
      flexDirection: 'column',
      alignItems: 'center',
      backgroundColor: theme.palette.black(0.35),
      margin: '0 auto',
      display: 'flex',
      justifyContent: 'center',
      pointerEvents: 'none',
      filter: `drop-shadow(0 0 0.75rem ${theme.palette.black(0.5)})`,
    },
    invisible: {
      opacity: 0,
      zIndex: -1,
      transition: 'opacity 0.5s, z-index 0s 0.6s',
    },
    'inner-container': {
      display: 'flex',
      gap: '3vh',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: 400,
      height: 400,
      borderRadius: '100%',
      backgroundColor: theme.palette.black(0.5),

      [`@media ${MOBILE}`]: {
        width: 200,
        height: 200,
        gap: '1vh',
      },

      [`@media ${TABLET}`]: {
        width: 250,
        height: 250,
        gap: '1vh',
      },

      '& > img': {
        width: 100,
        height: 100,
      },

      '& > div': {
        wordSpacing: '100vw',
        textAlign: 'center',
      },
    },
  })
